import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ModalController, NavController } from '@ionic/angular';
import { ServiceService } from 'src/app/services/service/service.service';
import {Location} from '@angular/common';
import { AreaService } from 'src/app/services/Area/area.service';
import { SetLocationComponent } from 'src/app/shared/set-location/set-location.component';
import { Meta, Title } from '@angular/platform-browser';
// import { google } from 'google-maps';
// declare var google: google;
@Component({
  selector: 'app-subservice',
  templateUrl: './subservice.page.html',
  styleUrls: ['./subservice.page.scss'],
})
export class SubservicePage implements OnInit {
serviceId:any;
allServices:any;
userData:any;
place:any;
// private geoCoder = new google.maps.Geocoder;

  constructor(
    private activatedroute:ActivatedRoute,
    private navCtrl:NavController,
    private r:Router,
    private _location: Location,
    private titleSer: Title,
    private meta: Meta,
    private modal:ModalController,
    private serviceService:ServiceService,
		private areaService:AreaService

  ) { 
    this.userData = JSON.parse(localStorage.getItem('userProfile'));
  }

  ngOnInit() {
    this.checkLocation();
    // this.getAddress();
  }
  goback(){
    console.log("sd");
    this.navCtrl.pop();
	  }


ngDoCheck(){
  if(this.serviceId !== this.activatedroute.snapshot.paramMap.get('id')){
    this.getServicessList(this.activatedroute.snapshot.paramMap.get('id'));
    this.serviceId = this.activatedroute.snapshot.paramMap.get('id');
  }
}
checkLocation(){
  if(localStorage.getItem('location')){
    this.place = localStorage.getItem('location');
  }
}


async getServicessList(serviceId){
  // if(!localStorage.getItem('locationId')){

  //   const modal = await this.modal.create({
  //     component: SetLocationComponent,
  //     cssClass: 'my-custom-class',
  //     swipeToClose: true,
  //   });
  //   await modal.present();
  //   const { data } = await modal.onWillDismiss();
  // }
  let locationId = localStorage.getItem('locationId');
  this.serviceService.searchServices({where:{"service_Name":serviceId.replace(/_/g, ' ')}}).then((res)=>{
    this.titleSer.setTitle('Fixitnow - '+ res[0].service_Name )
    this.meta.updateTag({ name: 'description', content:`New Plans Available Hurry Now. Fixit Now Home solution Pvt. Ltd. widely known as Fixit Now, is a registered company
    incorporated with a vision to make available a single platform where various repair and service
    needs of domestic & office clients are met with guaranteed quality standard at affordable cost.`});
    //facebook
    this.meta.updateTag({name:'og:type', content:"website"})
    this.meta.updateTag({name:"og:url",content:'http://fixitnow.in/subservice/'+res[0].service_Name})
    this.meta.updateTag({name:"og:title",content:res[0].service_Name})
    this.meta.updateTag({name:"og:description",content:`New Plans Available Hurry Now. Fixit Now Home solution Pvt. Ltd. widely known as Fixit Now, is a registered company
    incorporated with a vision to make available a single platform where various repair and service
    needs of domestic & office clients are met with guaranteed quality standard at affordable cost.`})
    this.meta.updateTag({name:"og:image",content:res[0].serviceBannerImage.url})
    //twitter
    this.meta.updateTag({name:'twitter:card', content:"summary_large_image"})
    this.meta.updateTag({name:"twitter:url",content:'http://fixitnow.in/subservice/'+res[0].service_Name})
    this.meta.updateTag({name:"twitter:title",content:res[0].service_Name})
    this.meta.updateTag({name:"twitter:description",content:`New Plans Available Hurry Now. Fixit Now Home solution Pvt. Ltd. widely known as Fixit Now, is a registered company
    incorporated with a vision to make available a single platform where various repair and service
    needs of domestic & office clients are met with guaranteed quality standard at affordable cost.`})
    this.meta.updateTag({name:"twitter:image",content:res[0].serviceBannerImage.url})

    this.serviceService.getAllServices(res[0].id,locationId).then((res)=>{
      console.log(res);
      this.allServices = res;
    })
  })

}


    nextPage(subservice){
      console.log(subservice);
      if(subservice.subServices && subservice.subServices.length > 0){
        console.log("nextpage");
        this.navCtrl.navigateForward("/subservice/"+subservice.service_Name.replaceAll(/ /g, '_'));
      }else{
        let data = {
          "serviceId":subservice.id,
          "service":subservice,
          "city":this.place,
          "locationId":localStorage.getItem("locationId"),
          "user":this.userData,
          "serviceName":subservice.service_Name,
          "measureableUnit":subservice.measureableUnitId
        }
        localStorage.setItem('JobData',JSON.stringify(data));
        if(subservice.measureableUnitId && subservice.measureableUnitId[0] && subservice.measureableUnitId[0] !== null ){

          this.navCtrl.navigateForward('/choose-functionality');
        }else{
          this.navCtrl.navigateForward('/service-detail');
        }
        // this.navCtrl.navigateForward('/choose-functionality');
      }
      
    }


  // getAddress() {
  //   if ('geolocation' in navigator) {
  //     navigator.geolocation.getCurrentPosition((position) => {
  //     this.geoCoder.geocode({ 'location': { lat: position.coords.latitude, lng: position.coords.longitude } }, (results, status) => {
  //       if (status === 'OK') {
  //       if (results[0]) {
  //         let plac = results[0].formatted_address.split(',');
  //         console.log(plac[plac.length - 3]);
  //         if(this.place){
  //           if(plac[plac.length - 3].toString().trim() !== this.place.toString().trim()){
  //             localStorage.setItem('location',plac[plac.length - 3]);
  //           }
  //         }else{
  //           this.place = plac[plac.length - 3];
  //           localStorage.setItem('location',plac[plac.length - 3]);
  //         }
  //       } else {
  //         window.alert('No results found');
  //       }
  //       } else {
  //       window.alert('Geocoder failed due to: ' + status);
  //       }
  //     });
  //   });
  // }
  // }
  ionViewDidEnter(){
    this.areaService.showHome=false  
  }
}
